<template>


    <v-container id="DetalleReporte" style="padding-top: 80px !important" class="pt-5">
        <div v-if="showcargando == true" id="cargando" style="z-index: 600;" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>

        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>

        </v-row>

        <v-layout row wrap id="cardColors">
            <v-flex xs12 sm6 md6>
                <v-card style="background-color: transparent !important" width="100%">


                    <v-card flat class="text-xs-center ma-3">

                        <v-card-title class="justify-center primary" @click="showGral = !showGral"
                            style="cursor: pointer;">
                            <v-icon style="margin-right:8px" color="white">
                                mdi-account
                            </v-icon>

                            <v-toolbar-title id="titulocard">Datos Generales</v-toolbar-title>
                            <v-spacer></v-spacer>

                            <v-icon :color="'#FFFFFF'">{{ showGral ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-card-title>

                        <v-expand-transition>
                            <div v-if="showGral">
                                <v-divider></v-divider>

                                <v-card-text>
                                    <vs-list>
                                        <vs-list-item title="Clave: " :subtitle="this.prclaveDes"></vs-list-item>
                                        <vs-list-item title="Razón social:" :subtitle="this.provInfo.prnombre">


                                            <v-row class="btnsAbo">

                                                <template v-if="this.provInfo.medallaUrl != null">
                                                    <div class="media-middle media-right" style="padding-left:0px">
                                                        <img class="sq-100" :src="this.provInfo.medallaUrl"
                                                            style="width: 40px; height: 40px; min-width: fit-content; margin-right:15px " />
                                                    </div>

                                                </template>

                                            </v-row>

                                        </vs-list-item>
                                        <vs-list-item title="Nombre comercial:"
                                            :subtitle="this.provInfo.prnomcom"></vs-list-item>
                                        <vs-list-item title="Dirección:">

                                        </vs-list-item>

                                        <v-textarea v-model="this.provInfo.prdirec" id="textareaobs" :disabled="true"
                                            outlined></v-textarea>

                                        <vs-list-item title="R.F.C.:" :subtitle="this.provInfo.prrfc"></vs-list-item>
                                        <vs-list-item title="CURP:" :subtitle="this.provInfo.prcurp"></vs-list-item>
                                        <vs-list-item title="Correo electrónico:"
                                            :subtitle="this.provInfo.premail"></vs-list-item>
                                        <vs-list-item title="Localidad:"
                                            :subtitle="this.provInfo.lonombre"></vs-list-item>
                                        <vs-list-item title="Estado:" :subtitle="this.provInfo.esnombre"></vs-list-item>
                                        <vs-list-item title="Centro de costos:"
                                            :subtitle="this.provInfo.cccentrocosto"></vs-list-item>
                                        <vs-list-item title="Tipo de proveedor:"
                                            :subtitle="this.provInfo.tptipo"></vs-list-item>

                                    </vs-list>


                                </v-card-text>
                            </div>
                        </v-expand-transition>


                    </v-card>


                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary" @click="showTel = !showTel"
                            style="cursor: pointer;">
                            <v-icon style="margin-right:8px" color="white">
                                mdi-phone
                            </v-icon>

                            <v-toolbar-title id="titulocard">Teléfonos</v-toolbar-title>
                            <v-spacer></v-spacer>

                            <v-icon :color="'#FFFFFF'">{{ showTel ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-card-title>
                        <v-expand-transition>
                            <div v-if="showTel">
                                <v-card-text style="margin-bottom: 4%;">
                                    <v-divider></v-divider>
                                    <v-spacer></v-spacer>



                                    <v-spacer></v-spacer>
                                    <v-card-text>
                                        <DataTable :url="urlListado" :columns="columns"
                                            :formatterActions="formatterActionsTels" :params="displayInputs"
                                            :order="[[0, 'desc']]" @apiDT="apiDT = $event" :movil="false"
                                            @Cancelar="CancelarShow"></DataTable>
                                    </v-card-text>

                                    <v-spacer></v-spacer>
                                </v-card-text>
                            </div>
                        </v-expand-transition>
                    </v-card>

                </v-card>

            </v-flex>
            <v-flex xs12 sm6 md6>
                <v-card style="background-color: transparent !important" width="100%">


                    <v-card flat class="text-xs-center ma-3">

                        <v-card-title class="justify-center primary" @click="showBan = !showBan"
                            style="cursor: pointer;">
                            <v-icon style="margin-right:8px" color="white">
                                mdi-credit-card
                            </v-icon>

                            <v-toolbar-title id="titulocard">Datos Bancarios</v-toolbar-title>
                            <v-spacer></v-spacer>

                            <v-icon :color="'#FFFFFF'">{{ showBan ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-card-title>
                        <v-expand-transition>
                            <div v-if="showBan">
                                <v-divider></v-divider>
                                <v-card-text>
                                    <DataTable :url="urlListadoBanco" :columns="columnsBanco" :params="displayInputs"
                                        :order="[[0, 'desc']]" @apiDT="apiDTBanco = $event" :movil="false"
                                        @Cancelar="CancelarShow">
                                    </DataTable>
                                </v-card-text>
                            </div>
                        </v-expand-transition>


                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="primary" @click="showOrg = !showOrg" style="cursor: pointer;">
                            <v-icon style="margin-right:8px" color="white">
                                mdi-source-branch
                            </v-icon>

                            <v-toolbar-title id="titulocard">Organigrama</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon :color="'#FFFFFF'">{{ showOrg ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-card-title>
                        <v-expand-transition>
                            <div v-if="showOrg">
                                <v-divider></v-divider>
                                <v-card-text>
                                    <vs-list>
                                        <vs-list-item title="Supervisoría: "
                                            :subtitle="this.provInfo.susupervisoria"></vs-list-item>
                                        <vs-list-item title="Supervisor: "
                                            :subtitle="this.provInfo.sunombre"></vs-list-item>
                                        <vs-list-item title="Supervisor teléfono: ">
                                            <template #subtitle>
                                                <span class="hoverTel"
                                                    v-if="permisoIVR && provInfo.prestatus == 'ACTIVO' && perfil != 'S'"
                                                    style="font-size: 20px; text-align: center; font-weight: 500;"
                                                    @click="llamadaIvrOrganigrama(provInfo.telefonoSupervisor, 'Supervisor')">
                                                    {{ provInfo.telefonoSupervisor }}
                                                </span>
                                                <span v-else
                                                    style="font-size: 20px; text-align: center; font-weight: 500;">
                                                    {{ provInfo.telefonoSupervisor }}
                                                </span>
                                            </template>
                                        </vs-list-item>
                                        <vs-list-item title="Supervisor de vehículos detenidos / robo: "
                                            :subtitle="provInfo.supervisor"></vs-list-item>
                                        <vs-list-item title="Supervisor de vehículos detenidos / robo teléfono: ">
                                            <template #subtitle>
                                                <span class="hoverTel"
                                                    v-if="permisoIVR && provInfo.prestatus == 'ACTIVO' && perfil != 'S'"
                                                    style="font-size: 20px; text-align: center; font-weight: 500;"
                                                    @click="llamadaIvrOrganigrama(provInfo.telefonoSupervisorVeh, 'Supervisor')">
                                                    {{ provInfo.telefonoSupervisorVeh }}
                                                </span>
                                                <span v-else
                                                    style="font-size: 20px; text-align: center; font-weight: 500;">
                                                    {{ provInfo.telefonoSupervisorVeh }}
                                                </span>
                                            </template>
                                        </vs-list-item>
                                        <vs-list-item title="Gerencia: "
                                            :subtitle="this.provInfo.genombre"></vs-list-item>
                                        <vs-list-item title="Gerente: "
                                            :subtitle="this.provInfo.geresponsable"></vs-list-item>
                                        <vs-list-item title="Gerente teléfono: ">
                                            <template #subtitle>
                                                <span class="hoverTel"
                                                    v-if="permisoIVR && provInfo.prestatus == 'ACTIVO' && perfil != 'G'"
                                                    style="font-size: 20px; text-align: center; font-weight: 500;"
                                                    @click="llamadaIvrOrganigrama(provInfo.telefonoGerente, 'Gerente')">
                                                    {{ provInfo.telefonoGerente }}
                                                </span>
                                                <span v-else
                                                    style="font-size: 20px; text-align: center; font-weight: 500;">
                                                    {{ provInfo.telefonoGerente }}
                                                </span>
                                            </template>
                                        </vs-list-item>
                                    </vs-list>
                                </v-card-text>
                            </div>
                        </v-expand-transition>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary" @click="showFec = !showFec"
                            style="cursor: pointer;">
                            <v-icon style="margin-right:8px" color="white">
                                mdi-calendar
                            </v-icon>

                            <v-toolbar-title id="titulocard">Fechas</v-toolbar-title>
                            <v-spacer></v-spacer>

                            <v-icon :color="'#FFFFFF'">{{ showFec ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-card-title>
                        <v-expand-transition>
                            <div v-if="showFec">
                                <v-divider></v-divider>
                                <v-card-text>
                                    <vs-list>
                                        <vs-list-item title="Alta: "
                                            :subtitle="this.provInfo.prpfecalta"></vs-list-item>

                                        <vs-list-item title="Baja: " :subtitle="this.provInfo.prfecbaja"></vs-list-item>

                                        <vs-list-item title="Reactivación: "
                                            :subtitle="this.provInfo.prfecreactivacion"></vs-list-item>


                                    </vs-list>
                                </v-card-text>
                            </div>
                        </v-expand-transition>


                    </v-card>
                    <v-card flat class="text-xs-center ma-3">

                        <v-card-title class="justify-center primary" @click="showInf = !showInf"
                            style="cursor: pointer;">
                            <v-icon style="margin-right:8px" color="white">
                                mdi-information
                            </v-icon>

                            <v-toolbar-title id="titulocard">
                                Otra Información
                            </v-toolbar-title>
                            <v-spacer></v-spacer>

                            <v-icon :color="'#FFFFFF'">{{ showInf ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-card-title>
                        <v-expand-transition>
                            <div v-if="showInf">
                                <v-divider></v-divider>
                                <v-card-text>
                                    <v-form ref="formauto" v-model="valid" lazy-validation>
                                        <vs-list>

                                            <span style="font-size: 12.8px; font-weight: 700; padding:5px"
                                                class="label-text">Persona: </span>
                                            <br />

                                            <template v-if="this.provInfo.prpersona == 'F'">
                                                <span class="personaClassF">FÍSICA</span>
                                            </template>

                                            <template v-if="this.provInfo.prpersona == 'M'">
                                                <span class="personaClassM">MORAL</span>
                                            </template>

                                            <v-divider></v-divider>

                                            <vs-list-item title="Estatus: "
                                                :subtitle="this.provInfo.prestatus"></vs-list-item>

                                            <vs-list-item title="Atiende RCP: "
                                                :subtitle="this.provInfo.prrcm"></vs-list-item>

                                            <vs-list-item title="Capturó: "
                                                :subtitle="this.provInfo.uslogin"></vs-list-item>

                                            <vs-list-item v-if="permisoVerIVR == true" title="IVR: "
                                                :subtitle="this.provInfo.privr"></vs-list-item>

                                        </vs-list>
                                    </v-form>
                                </v-card-text>
                            </div>
                        </v-expand-transition>

                    </v-card>


                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary" @click="showPod = !showPod"
                            style="cursor: pointer;">
                            <v-icon style="margin-right:8px" color="white">
                                mdi-zip-box
                            </v-icon>


                            <v-toolbar-title id="titulocard">Poderes</v-toolbar-title>
                            <v-spacer></v-spacer>

                            <v-icon :color="'#FFFFFF'">{{ showPod ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-card-title>
                        <v-expand-transition>
                            <div v-if="showPod">
                                <v-divider></v-divider>
                                <v-card-text>
                                    <DataTable :url="urlListadoPoderes" :columns="columnsPoderes"
                                        :params="displayInputs" :order="[[0, 'desc']]" @apiDT="apiDTPoderes = $event"
                                        :movil="false" @Cancelar="CancelarShow"></DataTable>
                                </v-card-text>
                            </div>
                        </v-expand-transition>

                    </v-card>
                </v-card>
            </v-flex>

            <br /><br />
        </v-layout>

    </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import General from '@/services/ReporteGeneral/ReporteGeneral.service.js';

import Proveedor from '@/services/Proveedor/Proveedor.service.js';

import Contacto from '@/services/DatosDeContacto/DatosContacto.service.js';
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable,
        Menu
    },
    data: function () {
        return {
            valid: true,
            showcargando: false,
            textoEjem: "Texto sample",
            provInfo: [],
            cargando: false,
            permisoIVR: false,
            permisoVerIVR: false,
            ivr: 0,
            prclaveDes: "",
            showTel: true,
            showNex: true,
            showGral: true,
            showBan: true,
            showOrg: true,
            showFec: true,
            showInf: true,
            showPod: true,
            datos: [],
            urlMedalla: '',
            //Tabla Telefonos
            urlListado: 'Proveedor/Proveedores_Telefonos',
            apiDT: null,
            columns: [
                { name: 'tcdesc', data: 'tcdesc', title: 'Descripción' },
                { name: "dcprdato", data: "dcprdato", title: "Teléfono", formatter: [this, "ivrData"], orderable: false },

            ],
            displayInputs: {
                nrreporte: 0,
                svindice: 0,
                prclave: "",
            },
            formatterActionsTels: [
                { click: [this, "llamadaIvr"] },

            ],

            //Tabla Banco
            urlListadoBanco: 'Proveedor/Proveedores_DetallesBancarios',
            apiDTBanco: null,
            columnsBanco: [
                { name: 'tipo', data: 'tipo', title: 'Tipo' },
                { name: 'banco', data: 'banco', title: 'Banco' },
                { name: 'relacion', data: 'relacion', title: 'Cuenta' },


            ],

            //Tabla Poderes
            urlListadoPoderes: 'Proveedor/Proveedores_Poderes',
            apiDTPoderes: null,
            columnsPoderes: [
                { name: 'poder', data: 'poder', title: 'Poder' },
                { name: 'cliente', data: 'cliente', title: 'Cliente' },
                { name: 'flotilla', data: 'flotilla', title: 'Flotilla' },
                { name: 'inicio', data: 'inicio', title: 'Inicio' },
                { name: 'fin', data: 'fin', title: 'Fin' },

            ],
            datos: {},
            supervehiculo: '',
            perfil: ''
        };
    },

    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
    watch: {

    },
    async mounted() {
        this.datos = await MetodosGenerales.obtenerSessionReporte("reporte");
        this.showcargando = true;

        await this.DatosCI();

        this.changeReporteMenuOption(this.$route.name);

        let formdata = new FormData();
        formdata.append("prclave", this.prclaveDes);
        var temp = await Proveedor.Proveedores_Detalle(this, formdata);
        this.provInfo = temp[0];


        this.showcargando = false;

        await this.reloadTable();



        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '54').then(response => {
            if (response.data.length > 0) {
                this.permisoVerIVR = true;
            }
        });
    },

    async created() {

        this.datos = await MetodosGenerales.obtenerSessionReporte("reporte");
        this.prclaveDes = this.datos.prclave;

        this.displayInputs.prclave = this.datos.prclave;
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        changeState(valor) {
            this.descripcion = this.motivos[valor - 1].mtmotivo;
        },
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }

            if (this.apiDTBanco != null) {
                this.apiDTBanco.ajax.reload(null, false);
                this.apiDTBanco.columns.adjust().responsive.recalc();
            }

            if (this.apiDTPoderes != null) {
                this.apiDTPoderes.ajax.reload(null, false);
                this.apiDTPoderes.columns.adjust().responsive.recalc();
            }
        },
        filter: function (evt) {
            evt = (evt) ? evt : window.event;
            let expect = evt.target.value.toString() + evt.key.toString();

            if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        seleccion() {
            if (this.posibleconclusion.length != 0)
                this.validarposible = false;
        },
        CancelarShow() {
            this.cargando = false;
        },

        async DatosCI() {

            let responseIVR = await Contacto.ObtenerCodigoIVR(this); //ObtenerIVR

            this.ivr = responseIVR[0].IVR;

            let estatus = await MetodosGenerales.getReporteEstatus();

            if (this.ivr != 0 && estatus == 1) {

                //Habilitar permiso IVR
                this.permisoIVR = true;
            }
            //else if (this.LLamarSintiempo && this.ivr != 0) {

            //    this.permisoIVR = true;
            //}
            let response = await Contacto.ObtenerPerfil(this);
            this.perfil = response.usperfil
        },

        async llamadaIvr(params, datos, fila) {
            let actor = await Contacto.ObtenerTipoActor(this, 'Abogado');
            await this.RealizarLlamada(datos.dcprdato, actor);
        },

        ivrData(datos) {
            if (datos.dcconsecutivo != null && this.permisoIVR == true && this.provInfo.prestatus == 'ACTIVO' && this.perfil != 'A') {
                return `<div><span class="mr-1 dt-formatterAction hoverTel" aria-haspopup="true" data-action="0" data-params="${datos}" title="Llamar" aria-ed="false"> ${datos.dcprdato} </span></div>`;
            }
            else {
                return `<div><span class="mr-1" aria-haspopup="true" data-params="${datos}" aria-expanded="false"> ${datos.dcprdato} </span></div>`;
            }
        },
        async RealizarLlamada(telefono, actor) {
            Contacto.LlamadaIVRServ(this, telefono, actor).then(datostel => {
                if (datostel !== null) {
                    window.location = 'tel:' + datostel;
                }
            });
        },
        async llamadaIvrOrganigrama(telefono, tipoActor) {
            let actor = await Contacto.ObtenerTipoActor(this, tipoActor);
            await this.RealizarLlamada(telefono, actor);
        },
    },
};
</script>

<style>
#cardColors .vs-list--title {
    color: #6b7280 !important;
}
</style>

<style scoped>
.text-subtitle {
    font-size: 12.8px;
    font-weight: 700;
    color: #6b7280 !important;
}



#DetalleReporte .vs-list--title {
    color: #6b7280 !important;
}

.text-title {
    color: #6b7280 !important;
}


.label-text2 {
    font-family: "Roboto", sans-serif;
    font-weight: 700 !important;
    font-size: 20px !important;
    margin-bottom: 0px !important;
}

.btnsAbo {
    flex-wrap: initial !important;
}

.primerAtencion-container {
    background-color: white;
}

.hoverTel:hover {
    background-color: lightskyblue;
    cursor: pointer;
}

.personaClassF {
    border: 1px solid transparent;
    display: inline-block;
    font-size: 85%;
    font-weight: 600;
    padding: 0.3em 0.6em;
    position: relative;
    background-color: #43a047;
    color: white;
    border-radius: 6px;
    margin: 5px;
}

.personaClassM {
    border: 1px solid transparent;
    display: inline-block;
    font-size: 85%;
    font-weight: 600;
    padding: 0.3em 0.6em;
    position: relative;
    background-color: #0288d1;
    color: white;
    border-radius: 6px;
    margin: 5px;
}
</style>

<style lang="scss">
@media screen and (max-width: 700px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 0.9rem;
        color: gray;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 1rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 700px) and (max-width: 1060px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 1rem;
        color: gray;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 1.1rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 1060px) and (max-width: 1364px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 1rem;
        color: gray;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 1.1rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 1364px) and (max-width: 2004px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 1.2rem;
        color: gray;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 1.3rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 2004px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 1.3rem;
        color: gray;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 1.4rem;
        font-weight: 700;
    }
}

#correo .list-titles {
    max-width: -webkit-fill-available !important;
}
</style>